/* @flow */

export const WHITELIST_ENDPOINT = '/services/global/whitelist-terms';



// WEBPACK FOOTER //
// ./src/app/modules/global-whitelist/constants.js